
import { PropType } from 'vue'
import { Comentario } from '@/models/comentario_model';
import { PassaporteUsuarioLogado } from '@/libs/passaporte/models/passaporte_usuario_logado_model';

export default {
    name: 'kooponComumComentarios',
    props: {
        anotacoes: {
            type: Array as PropType<Comentario[]>,
            required: true
        },
        usuarioAutenticado: {
            type: PassaporteUsuarioLogado,
            required: true
        }, 
        exibeHintComentario: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        comentario: new Comentario(),
        comentarios: [] as Comentario[]
    }),

    mounted() {
        this.comentarios = [...this.anotacoes]
    },

    methods: {
        adicionarComentario(novoComentario:Comentario) {
            novoComentario.nomeUsuarioPassaporte = this.usuarioAutenticado.nomeUsuario;
            this.comentarios.unshift(novoComentario);

            this.comentario = new Comentario();
        },

        removerComentario(index:number) {
            this.comentarios.forEach((c, i) => {
                if (i === index) {
                    return this.comentarios.splice(i, 1);
                }
            });
        }
    },
    watch: {
        'comentario.texto'() {
            this.$emit('atualizaCampoComentario', this.comentario.texto)
        },
        comentarios() {
            this.$emit('update', this.comentarios)
        }
    }
};
